import { jsxs as e, jsx as o } from "react/jsx-runtime";
const n = (r) => /* @__PURE__ */ e(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...r,
    children: [
      /* @__PURE__ */ o(
        "path",
        {
          stroke: "currentcolor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 2,
          d: "M19.933 13.04a8 8 0 1 1-9.925-8.787c3.9-1 7.935 1.007 9.425 4.747"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          stroke: "currentcolor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 2,
          d: "M20 4v5h-5"
        }
      )
    ]
  }
);
export {
  n as default
};
